import React, { FC, Suspense } from "react"
import type { KeyboardShortcut } from "resha"
import { Loader } from "dash-styled"

const ReshaAnnotationShortcutListItem = React.lazy(async () => {
    return import("resha").then(resha => ({
        default: resha.AnnotationShortcutListItem
    }))
})

export interface AnnotationShortcutListItemProps {
    shortcut: KeyboardShortcut
    active: boolean
}

export const AnnotationShortcutListItem: FC<AnnotationShortcutListItemProps> =
    props => (
        <Suspense fallback={<Loader size="xxxl" />}>
            <ReshaAnnotationShortcutListItem {...props} />
        </Suspense>
    )
